import styled, { css } from 'styled-components';
import Icon from '../../../_shared/components/Icon';

export const StyledSavedFilters = styled.div`
  max-height: 100%;
  background-color: ${props =>
    props.isFilterSelected
      ? props.theme.COLORS.NEUTRAL_50
      : props.theme.COLORS.NEUTRAL_5};
  padding: 11px;
  margin-left: -12px;
  margin-right: -10px;
`;

export const StyledSelectedFilter = styled.div`
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL_50};
`;

const watchlistImpoundVariant = {
  true: css`
    margin: 12px 0 0 0;
  `,
  false: css`
    font-style: italic;
    margin: 12px 0;
  `
};

export const StyledDisplayFilterName = styled.p`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  ${props => watchlistImpoundVariant[props.isWatchlistOrImpound]};
  width: 218px;
  overflow: hidden;
  text-overflow: ellipsis;
  span {
    font-style: normal;
    font-family: ${({ theme }) => theme.FONT.REGULAR};
  }
`;

export const StyledNotificationsToggle = styled.div`
  display: flex;
  flex-direction: row;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  margin-bottom: 12px;
`;

export const Title = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  margin-bottom: 6px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;

export const SavedFilterHeader = styled.div`
  display: flex;
  color: ${({ theme }) => theme.COLORS.MID_GREY};
  line-height: 14px;
`;

export const ArrowDownIcon = styled(Icon).attrs({
  icon: 'TR5-Dropdown'
})`
  width: 12px;
  height: 16px;
`;

export const ArrowUpIcon = styled(Icon).attrs({
  icon: 'TR5-Dropdown'
})`
  width: 12px;
  height: 24px;
`;

/**
 * Saved Filter Dropdown
 */
export const Dropdown = styled.div`
  background-color: ${({ theme }) => theme.COLORS.BASE};
  border: 1px solid ${({ theme }) => theme.COLORS.NEUTRAL_10};
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  width: 278px;
  max-height: 500px;
  padding: 11px 12px 17px;
  overflow-y: auto;
`;

export const DropdownHeader = styled.div`
  color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
  background: ${({ theme }) => theme.COLORS.BASE};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  line-height: 14px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const FilterOptionsVariant = {
  true: css`
    padding: 14px 0 11px;
  `,
  false: css`
    border-bottom: 2px solid ${({ theme }) => theme.COLORS.NEUTRAL_50};
    padding: 12px 0;
  `
};

export const FilterOptions = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;

  &:last-child {
    margin-bottom: 0;
  }

  &:nth-child(2) {
    padding-top: 0;
  }

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  ${props => FilterOptionsVariant[props.noBorder]};

  ${props =>
    props.isSelected &&
    css`
      font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
    `}
`;

export const FilterName = styled.div`
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  line-height: 14px;
  width: 222px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TrashCan = styled(Icon).attrs({
  icon: 'TR5-Trashcan'
})`
  width: 18px;
  height: 18px;
`;

/**
 * Delete Filter Modal
 */
export const ModalContainer = styled.div`
  height: 100%;
  max-height: 217px;
`;

ModalContainer.Header = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  margin-bottom: 21px;
`;

ModalContainer.Body = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  margin-bottom: 24px;
`;

ModalContainer.Footer = styled.div`
  display: flex;
`;

export const CancelButton = styled.button`
  margin-left: auto;
  border: none;
  background: none;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  margin-right: 30px;
  cursor: pointer;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.WIDE};
`;

export const DeleteButton = styled.button`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  background-color: ${({ theme }) => theme.COLORS.TERTIARY};
  border-radius: 4px;
  border: none;
  color: ${({ theme }) => theme.COLORS.BASE};
  width: 125px;
  height: 36px;
  cursor: pointer;
  letter-spacing: ${({ theme }) => theme.LETTER_SPACING.WIDE};
`;
